import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithTwoDecimal } from '../../../components/functions'

import { useEnergiaIluminacaoContext } from '../../../context/energiaIluminacaoContext'

import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {


    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()
    const { energiaIluminacao_id, setEnergiaIluminacao_id } = useEnergiaIluminacaoContext()

    const [tipoTecnologia, setTipoTecnologia] = useState('')
    const [marca, setMarca] = useState('')
    const [quantidade, setQuantidade] = useState('')
    const [marcaReator, setMarcaReator] = useState('')
    const [modelo, setModelo] = useState('')
    const [ligacaoReator, setLigacaoReator] = useState('')

    const [potenciaUnitaria, setPotenciaUnitaria] = useState('')
    const [fatorPotencia, setFatorPotencia] = useState('')
    const [fluxoLuminoso, setFluxoLuminoso] = useState('')
    const [irc, setIrc] = useState('')
    const [vidaUtil, setVidaUtil] = useState('')
    const [temperaturaCor, setTemperaturaCor] = useState('')

    //const [ambiente, setAmbiente] = useState('')
    const [energiaAmbiente_id, setEnergiaAmbiente_id] = useState()
    const [ilumnHorasDia, setIlumHorasDia] = useState('')
    const [diaSemana, setDiaSemana] = useState('')
    const [semanasAno, setSemanasAno] = useState('')
    const [status, setStatus] = useState('')

    
    const [resultadoAmbientes, setResultadoAmbientes] = useState()

    const [resultadoIluminacao, setResultadoIluminacao] = useState()

    const [resultadoMarcaIluminacao, setResultadoMarcaIluminacao] = useState()



    function limpaDados() {

        setTipoTecnologia('')
        setMarca('')
        setQuantidade('')
        setMarcaReator('')
        setModelo('')
        setLigacaoReator('')
        setPotenciaUnitaria('')
        setFatorPotencia('')
        setFluxoLuminoso('')
        setIrc('')
        setVidaUtil('')
        setTemperaturaCor('')
        setEnergiaAmbiente_id('')
        setIlumHorasDia('')
        setDiaSemana('')
        setSemanasAno('')
        setStatus('')

    }

    function carregaMarcaIluminacao() {

        api.get(`energiaIluminacaoMarcaListaTodos`).then((result) => {

            //console.log(result.data)
            setResultadoMarcaIluminacao(result.data.map((rs) =>
            
                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function carregaAmbientes() {

        if (energia_id) {

            api.get(`energiaAmbienteLista/${energia_id}`).then((result) => {

                //console.log(result.data)
                setResultadoAmbientes(result.data.map((rs) =>

                    <option value={rs.energiaAmbiente_id} key={rs.energiaAmbiente_id}>{rs.identificacao}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }



    function carregaIluminacaoDet() {


        if (energiaIluminacao_id) {


            api.get(`energiaIluminacaoListaUm/${energiaIluminacao_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data[0]

                setTipoTecnologia(data.tipoTecnologia)
                setMarca(data.marca)
                setModelo(data.modelo)
                setQuantidade(data.quantidade)
                setMarcaReator(data.marcaReator)
                setLigacaoReator(data.ligacaoReator)
                setPotenciaUnitaria(data.potenciaUnitaria)
                setFatorPotencia(data.fatorPotencia)
                setFluxoLuminoso(data.fluxoLuminoso)
                setIrc(data.irc)
                setVidaUtil(data.vidaUtil)
                setTemperaturaCor(data.temperaturaCor)
                setEnergiaAmbiente_id(data.energiaAmbiente_id)
                setIlumHorasDia(data.ilumnHorasDia)
                setDiaSemana(data.diaSemana)
                setSemanasAno(data.semanasAno)
                setStatus(data.status)


            }).catch((err) => {

                console.log(err.response)

            })


        }


    }





    function apagaIluminacao() {

        if (energiaIluminacao_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaIluminacao/${energiaIluminacao_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            //consultaIluminacao()
                            //window.toastr.sucess('Registro apagado com sucesso')

                            window.$('#modalEnergiaIluminacao').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }


    function salvaIluminacao() {

        if (tipoTecnologia == '') {

            window.toastr.error('<b>Tipo/Tecnologia</b> não pode ficar em branco!')
            return false

        }

        if (marca == '') {

            window.toastr.error('<b>Marca</b> não pode ficar em branco!')
            return false

        }


        if (modelo == '') {

            //window.toastr.error('<b>Modelo</b> não pode ficar em branco!')
            //return false

        }


        if (quantidade == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        }

        if (potenciaUnitaria == '') {

            window.toastr.error('<b>Potência Unitária [W]</b> não pode ficar em branco!')
            return false

        } else {

            if (potenciaUnitaria == '0') {

                window.toastr.error('<b>Potência Unitária [W]</b> deve zer maior que zero!')
                return false

            }

        }


        if (fluxoLuminoso == '') {

            window.toastr.error('<b>Fluxo Luminoso [lm]</b> não pode ficar em branco!')
            return false

        }

        if (marcaReator == '') {

            //window.toastr.error('<b>Marca do reator</b> não pode ficar em branco!')
            //return false

        }

        if (ligacaoReator == '') {

            //window.toastr.error('<b>Ligação no reator</b> não pode ficar em branco!')
            //return false

        }

        if (ilumnHorasDia == '') {


            window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(ilumnHorasDia) > 24) {

                window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ser maior que 24!')
                return false

            }


        }


        if (diaSemana == '') {


            window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(diaSemana) > 7) {

                window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ser maior que 7!')
                return false

            }


        }


        if (semanasAno == '') {


            window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(semanasAno) > 52) {

                window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ser maior que 52!')
                return false

            }


        }

        if (fatorPotencia != '') {

            if (parseFloat(fatorPotencia.replaceAll(',', '.')) == 0 || parseFloat(fatorPotencia.replaceAll(',', '.')) > 1) {

                window.toastr.error('<b>Fator de potência</b> deverá ser maior que zero e menor ou igual a 1!')
                return false

            }

        }

        if (fluxoLuminoso != '') {

            if (fluxoLuminoso == '0') {

                window.toastr.error('<b>Fluxo Luminoso</b> não pode ser igual a zero!')
                return false

            }

        }


        if (irc != '') {

            if (parseFloat(irc.replaceAll(',', '.')) == 0 || parseFloat(irc.replaceAll(',', '.')) > 100) {

                window.toastr.error('<b>IRC</b> deverá ser maior que zero e menor ou igual a 100!')
                return false

            }

        }


        if (status == '') {

            window.toastr.error('<b>Status</b> não pode ficar em branco!')
            return false

        }



        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            modelo: modelo,
            tipoTecnologia: tipoTecnologia,      
            marca: marca,      
            quantidade: quantidade == null ? '' : quantidade.toString(),
            marcaReator: marcaReator,
            
            ligacaoReator: ligacaoReator,
            potenciaUnitaria: potenciaUnitaria == null ? '' : potenciaUnitaria.toString(),
            fatorPotencia: fatorPotencia == null ? '' : fatorPotencia.toString(),
            fluxoLuminoso: fluxoLuminoso == null ? '' : fluxoLuminoso.toString(),
            irc: irc == null ? '' : irc.toString(),
            vidaUtil: vidaUtil == null ? '' : vidaUtil.toString(),
            temperaturaCor: temperaturaCor,
            //ambiente: ambiente,
            energiaAmbiente_id: energiaAmbiente_id,
            ilumnHorasDia: ilumnHorasDia == null ? '' : ilumnHorasDia.toString(),
            diaSemana: diaSemana == null ? '' : diaSemana.toString(),
            semanasAno: semanasAno == null ? '' : semanasAno.toString(),
            status: status,

        }


        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaIluminacao_id) {

                        //console.log('put')

                        api.put(`energiaIluminacao/${energiaIluminacao_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //if (result.data.status == 'ok') {
    
                                //setShow(false)
                                //consultaIluminacao()

                                window.$('#modalEnergiaIluminacao').modal('hide')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                                window.toastr.success('Registro salvo com sucesso!')
    
    
                            //}
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaIluminacao', dataPost).then((result) => {

                            //console.log(result.data)
                            //if (result.data.status == 'ok') {
    
                                //setShow(false)
                                //consultaIluminacao()
                                //window.toastr.success('Registro salvo com sucesso!')

                                window.$('#modalEnergiaIluminacao').modal('hide')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                                window.toastr.success('Registro salvo com sucesso!')
    
    
                            //}
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }



    const handleChange = (e) => {
        e.preventDefault();
    }



    useEffect(() => {

        limpaDados()
        carregaMarcaIluminacao()
        carregaIluminacaoDet()
        carregaAmbientes()

    }, [energiaIluminacao_id])



    return (

        <div>

                <div className="modal fade" id="modalEnergiaIluminacao" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Iluminação</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">



                            <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                            </div>
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Tipo/Tecnologia *
                                                <div class="tooltip">
                                                selecionar o tipo/tecnologia da lâmpada ou grupo de lâmpadas.
                                                </div>
                                            </span>

                                        </label>
                                    
                                        
                                        <select class="form-control" value={tipoTecnologia} onChange={event => setTipoTecnologia(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Fluorescente Tubular">Fluorescente Tubular</option>
                                            <option value="Fluorescente Compacta (Bulbo)">Fluorescente Compacta (Bulbo)</option>
                                            <option value="LED Tubular">LED Tubular</option>
                                            <option value="LED Compacta (Bulbo)">LED Compacta (Bulbo)</option>
                                            <option value="PAR LED">PAR LED</option>
                                            <option value="Luminária LED">Luminária LED</option>
                                            <option value="Incandescente">Incandescente</option>
                                            <option value="Vapor Metálico">Vapor Metálico</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Marca *</label>
                                        <select class="form-control" value={marca} onChange={event => setMarca(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {resultadoMarcaIluminacao}
                                            
                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Modelo
                                                <div class="tooltip">
                                                digite o modelo conforme especificado pelo fabricante. Note que modelo é diferente do tipo ou da marca da lâmpada (opcional).

                                                </div>
                                            </span>

                                        </label>
                                        
                                        <input class="form-control" input="text" value={modelo} onChange={event => setModelo(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)} 
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        />
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" style={{ display: tipoTecnologia == 'Fluorescente Tubular' ? 'table-row' : 'none'}}>
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Marca do reator</label>
                                        <input class="form-control" input="text" value={marcaReator} onChange={event => setMarcaReator(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6"  style={{ display: tipoTecnologia == 'Fluorescente Tubular' ? 'table-row' : 'none'}}>
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Ligação no Reator</label>
                                        <select class="form-control" value={ligacaoReator} onChange={event => setLigacaoReator(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="1 Lâmpada por Reator">1 Lâmpada por Reator</option>
                                            <option value="2 Lâmpadas por Reator">2 Lâmpadas por Reator</option>
                                            <option value="3 Lâmpadas por Reator">3 Lâmpadas por Reator</option>
                                            <option value="4 Lâmpadas por Reator">4 Lâmpadas por Reator</option>
                                            <option value="5 Lâmpadas por Reator">5 Lâmpadass por Reator</option>
                                            <option value="6 Lâmpadas por Reator">6 Lâmpada por Reator</option>
                                        </select>
                                            
                                    </div>
                                </div>


                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência Unitária [W] *</label>
                                            <input class="form-control" input="text" value={potenciaUnitaria} onChange={event => setPotenciaUnitaria(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Fator de Potência
                                                    <div class="tooltip">
                                                    digite o fator de potência (número adimensional menor que 1) especificado pelo fabricante (opcional).

                                                    </div>
                                                </span>

                                            </label>
                                        
                                            <input class="form-control" input="text" value={fatorPotencia} onChange={event => setFatorPotencia(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >


                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Fluxo Luminoso [lm] *
                                                    <div class="tooltip">
                                                    digite o fluxo luminoso em Lúmens especificado pelo fabricante.

                                                    </div>
                                                </span>

                                            </label>
                                        
                                        
                                            <input class="form-control" input="text" value={fluxoLuminoso} onChange={event => setFluxoLuminoso(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    IRC
                                                    <div class="tooltip">
                                                    digite o Índice de Reprodução de Cores especificado pelo fabricante (valor até 100) (opcional).

                                                    </div>
                                                </span>

                                            </label>
                                        
                                            
                                            <input class="form-control" input="text" value={irc} onChange={event => setIrc(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Vida Útil [h]</label>
                                            <input class="form-control" input="text" value={vidaUtil} onChange={event => setVidaUtil(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Temperatura de Cor [K]</label>
                                            <select class="form-control" value={temperaturaCor} onChange={event => setTemperaturaCor(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="1000 - 1999">1000 - 1999</option>
                                                <option value="2000 - 2999">2000 - 2999</option>
                                                <option value="3000 - 3999">3000 - 3999</option>
                                                <option value="4000 - 4999">4000 - 4999</option>
                                                <option value="5000 - 5999">5000 - 5999</option>
                                                <option value="6000 - 6999">6000 - 6999</option>
                                                <option value="7000 - 7999">7000 - 7999</option>
                                                <option value="8000 - 8999">8000 - 8999</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>


                                    <div className="col-md-12" >
                                        <br/><br/>
                                        <b>Dados Operacionais</b>
                                        <br/><br/>
                                    </div>
                                        
                                        
                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Ambiente</label>
                                                <select class="form-control" value={energiaAmbiente_id} onChange={event => setEnergiaAmbiente_id(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    {resultadoAmbientes}
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [h/dia] *</label>
                                                <input class="form-control" input="text" value={ilumnHorasDia} onChange={event => setIlumHorasDia(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [dias/semana] *</label>
                                                <input class="form-control" input="text" value={diaSemana} onChange={event => setDiaSemana(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [semanas/ano] *</label>
                                                <input class="form-control" input="text" value={semanasAno} onChange={event => setSemanasAno(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Status *</label>
                                                <select class="form-control" value={status} onChange={event => setStatus(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="Em Operação">Em Operação</option>
                                                    <option value="Inoperante (queimada)">Inoperante (queimada)</option>
                                                </select>
                                                    
                                            </div>
                                        </div>

                                
                                

                            </div>





                            </div>
                            <div className="modal-footer">


                                <button type="button" className="btn btn-danger" onClick={() => apagaIluminacao()} style={{ display: energiaIluminacao_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaIluminacao()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal